import type { GenerationJobRow } from "@/types/workspace"

export function inFlightPropSketchEditJob(
  jobs: GenerationJobRow[],
  propId: number,
  match: { target: "front_view" | "reference"; stateId?: number | null },
): GenerationJobRow | null {
  const id = Number(propId)
  const wantState = match.stateId ?? null
  return (
    jobs.find((j) => {
      if (j.job_kind !== "sketch_edit") return false
      if (Number(j.prop_id) !== id) return false
      if (j.status !== "queued" && j.status !== "processing") return false
      if (j.sketch_prop_target !== match.target) return false
      return (j.prop_state_id ?? null) === wantState
    }) ?? null
  )
}

export function propFrontViewJob(jobs: GenerationJobRow[], propId: number): GenerationJobRow | null {
  const id = Number(propId)
  return (
    jobs.find(
      (j) =>
        j.job_kind === "prop_front_view" &&
        Number(j.prop_id) === id &&
        (j.status === "queued" || j.status === "processing"),
    ) ?? inFlightPropSketchEditJob(jobs, propId, { target: "front_view" })
  )
}

export function propFrontViewBusy(jobs: GenerationJobRow[], propId: number) {
  return propFrontViewJob(jobs, propId) != null
}

export function propReferenceJob(jobs: GenerationJobRow[], propId: number): GenerationJobRow | null {
  const id = Number(propId)
  return (
    jobs.find(
      (j) =>
        j.job_kind === "prop_reference" &&
        Number(j.prop_id) === id &&
        (j.prop_state_id ?? null) === null &&
        (j.status === "queued" || j.status === "processing"),
    ) ?? inFlightPropSketchEditJob(jobs, propId, { target: "reference", stateId: null })
  )
}

export function propReferenceBusy(jobs: GenerationJobRow[], propId: number) {
  return propReferenceJob(jobs, propId) != null
}

export function stateReferenceJob(jobs: GenerationJobRow[], propId: number, stateId: number): GenerationJobRow | null {
  const pid = Number(propId)
  const sid = Number(stateId)
  return (
    jobs.find(
      (j) =>
        j.job_kind === "prop_reference" &&
        Number(j.prop_id) === pid &&
        Number(j.prop_state_id) === sid &&
        (j.status === "queued" || j.status === "processing"),
    ) ?? inFlightPropSketchEditJob(jobs, propId, { target: "reference", stateId })
  )
}

export function stateReferenceBusy(jobs: GenerationJobRow[], propId: number, stateId: number) {
  return stateReferenceJob(jobs, propId, stateId) != null
}

export function propStripBusy(jobs: GenerationJobRow[], propId: number) {
  return propReferenceBusy(jobs, propId) || propFrontViewBusy(jobs, propId)
}
